import { TourEvent } from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';
import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';

/**
 * Prepare map that list all tour travels linked to a tour event
 */
export function prepareTourTravelsToDisplayList(
  tourEvents: TourEvent[],
  tourTravels: TourTravel[],
): Record<number, TourTravel[]> {
  const tourTravelsByTourEventId = tourEvents.reduce<
    Record<TourEvent['id'], TourTravel[]>
  >((acc, tourEvent) => {
    // incoming travels to this event
    const linkedIncoming = tourTravels.filter(
      (x) =>
        x.connexionTypeWithEvent === 'incoming' && x.toEventId === tourEvent.id,
    );
    // outgoing travels from this event
    const linkedOutcoming = tourTravels.filter(
      (x) =>
        x.connexionTypeWithEvent === 'outgoing' &&
        x.fromEventId === tourEvent.id,
    );
    // direct travels from this event
    const linkedDirect = tourTravels.filter(
      (x) =>
        x.connexionTypeWithEvent === 'direct' && x.fromEventId === tourEvent.id,
    );
    acc[tourEvent.id] = [
      ...linkedIncoming,
      ...linkedOutcoming,
      ...linkedDirect,
    ];
    return acc;
  }, {});
  return tourTravelsByTourEventId;
}
